"use strict";
exports.__esModule = true;
exports.EMBED_UPDATE_CARD_BILLING_ADDRESS = void 0;
exports.EMBED_UPDATE_CARD_BILLING_ADDRESS = {
    BODY: 'Enter the information associated with your card.',
    CTA: 'Save',
    HEADER: 'Update billing information'
};
